import {Group} from './groups';
import {PageUser} from './pages';

// info about the access request that we
// get after creating it
export interface AccessRequestInfo {
    requested_at: string;
    reason: string;
}

export interface AccessRequest extends AccessRequestInfo {
    id: number;
    status: 'pending' | 'processed';
    applicant: AccessRequestApplicant;
    resolution: AccessRequestResolution | null;
}

export interface AccessRequestApplicant {
    user: PageUser;
    departments: Group[];
    services: Group[];
}

interface AccessRequestResolution {
    decision: 'allow' | 'deny';
    processed_by: PageUser;
    comment: string | null;
}

export enum AccessRequestDecision {
    Deny = 'deny',
    AllowApplicant = 'allow_applicant',
    AllowGroups = 'allow_groups',
}
